// eslint-disable-next-line no-redeclare
import _ from 'lodash';

/**
 * Service related to app's pages.
 */
angular.module('hjApp').service('Page', [
    '$state',
    function ($state) {
        var self = this;

        /**
         * Get the "type" of page this state is for.
         */
        self.getType = function () {
            var currentSection = $state.current.name.split('.')[0],
                pageType;

            if (_.includes(['settings', 'site', 'team', 'sso'], currentSection)) {
                pageType = 'setting';
            } else if (currentSection === 'profile') {
                pageType = 'profile';
            } else {
                pageType = 'feature';
            }

            return pageType;
        };
    }
]);
